import * as z from 'zod'
import { TFunction } from 'i18next'
import { AdvanceFiscalType } from './input/advance-fiscal-type-input'
import { getDocumentCustomerIssues, getDocumentCustomerSchema } from 'src/app/components/document-customer-input/document-customer-schema'

export function getDepositFormSchema(t?: TFunction, unpaidPaymentActiveIds?: string[]) {
  return z
    .object({
      amount: z.number().gt(0),
      advanceFiscalType: z.nativeEnum(AdvanceFiscalType),
      vatId: z.string().optional(),
      customer: getDocumentCustomerSchema(),
      payments: z
        .object({
          paymentActiveId: z.string().min(1),
          amount: z.number().gt(0),
          editable: z.boolean().default(true),
          expireDate: z.date().optional().nullable(),
        })
        .array()
        .min(1),
      scelNote: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      const paymentSum = data.payments.reduce((prev, current) => {
        return prev + (current.amount || 0)
      }, 0)

      const totalAmount = data.amount

      if (data.amount && data.amount > 0 && paymentSum !== totalAmount) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t?.('pms.booking.reservation.create_deposit.payments_error'),
          path: ['payments'],
        })
      }

      const customerIssues = getDocumentCustomerIssues('customer', data.customer, data.advanceFiscalType, t)
      customerIssues.forEach((i) => ctx.addIssue(i))

      const hasUnpaidPaymentActive = data.payments.some((p) => p.paymentActiveId && unpaidPaymentActiveIds?.includes(p.paymentActiveId))

      if (hasUnpaidPaymentActive) {
        const isValid = data.payments
          .filter((p) => p.paymentActiveId)
          .every((p) => {
            // Typescript anomaly p.paymentActiveId can't be undefined because it was checked with filter
            if (unpaidPaymentActiveIds?.includes(p.paymentActiveId!) && (p.expireDate === undefined || p.expireDate === null)) return false
            return true
          })

        if (!isValid) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t?.('pms.accounting.documents.missing_unpaid_expiration_date'),
            path: ['payments'],
          })
        }
      }
      return true
    })
}

const depositFormSchema = getDepositFormSchema()
export type DepositFormSchema = z.infer<typeof depositFormSchema>
